export const SET_GLOBAL_SEARCH_TEXT = 'SET_GLOBAL_SEARCH_TEXT';
